import { defineMeta } from '@/registry/types';

export const modalMeta = defineMeta({
  name: 'Modal',
  level: 'organism',
  category: 'feedback',
  classification: 'themed-mui',
  description: 'Low-level overlay primitive for fully custom modal content. Themed MUI Modal.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Modal',
  muiDocs: 'https://mui.com/material-ui/react-modal/',
  a2uiEquivalent: 'Modal',
  importPath: '@/organisms/Modal',
  requiredProps: ['open', 'children'],
  optionalProps: ['onClose', 'keepMounted'],
  supportedStates: ['open', 'closed'],
  designTokens: ['colors', 'radius', 'shadows'],
  accessibility: ['Provide aria-labelledby/aria-describedby on the content.'],
  usageExamples: ['<Modal open={open} onClose={close}><Box>...</Box></Modal>'],
  antiPatterns: ['Prefer Dialog for standard confirmations/forms.'],
  mountsSurface: 'portal',
  llmSafe: false,
  whenToUse: ['Custom overlays not covered by Dialog'],
  whenNotToUse: ['Standard confirmations (use Dialog)'],
});

export default modalMeta;
